/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingInformationForAzureSubscription extends models.BillingPeriodInformation {
    getFixupPrototypeFunction() { return BillingInformationForAzureSubscription.fixupPrototype; }

    static newInstance(model: Partial<BillingInformationForAzureSubscription>): BillingInformationForAzureSubscription {
        let obj = Object.assign(new BillingInformationForAzureSubscription(), model);
        BillingInformationForAzureSubscription.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingInformationForAzureSubscription>): BillingInformationForAzureSubscription {
        if (!model) return null;
        return BillingInformationForAzureSubscription.newInstance(<BillingInformationForAzureSubscription> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingInformationForAzureSubscription) {
        if (!obj) return;

        models.BillingInformationForAzureSubscription.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingInformationForAzureSubscription): boolean {
        if (models.BillingPeriodInformation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingInformationForAzureSubscription.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
